import React from "react";
import { Column } from "react-foundation";
import utils from "../utils/index";

const ItemSelectorTab = ({ type, name, selected, onClick, background, ProductSuites, customerColour, loading }) => (
    !loading && utils.checkProductSuiteExists(type ,ProductSuites) && (
        <Column
            onClick={() => onClick({ selectedItem: name })}
            className={selected === name ? "mobile-item-grid selected" : "mobile-item-grid"}
            small={6}
        >
            <img src={background} className={selected === name ? "" : "grey"} alt=""/>
            <div className={selected === name ? "item-selector-label" : "item-selector-label grey"}  style={{backgroundColor: customerColour}}>
                {name}
            </div>
        </Column>
    )
);

export default ItemSelectorTab;


// WEBPACK FOOTER //
// ./src/components/ItemSelectorTab.js